// 公共组件埋点相关
export const YscClstags = {
  // 头部导航埋点
  header: {
    home: 'pageclick|keycount|home_201711226|1',
    il: 'pageclick|keycount|home_201711226|2',
    ihs: 'pageclick|keycount|home_201711226|3',
    sfs: 'pageclick|keycount|home_201711226|4',
    pbs: 'pageclick|keycount|home_201711226|5',
    vrs: 'pageclick|keycount|home_201711226|6',
    report: 'pageclick|keycount|home_201711226|7', // 报表中心
    auth: 'pageclick|keycount|home_201711226|32', // 权限管理
    pisc: 'pageclick|keycount|home_201711226|34' // 入仓计算器
  },
  home: {
    comOperation_il: 'pageclick|keycount|home_201711226|13',
    comOperation_ihs: 'pageclick|keycount|home_201711226|14',
    comOperation_sfs: 'pageclick|keycount|home_201711226|15',
    comOperation_pbsPre: 'pageclick|keycount|home_201711226|16',
    comOperation_pbsSep: 'pageclick|keycount|home_201711226|17',
    comOperation_vrs: 'pageclick|keycount|home_201711226|18',
    todo_sfs: 'pageclick|keycount|home_201711226|19',
    todo_vrs: 'pageclick|keycount|home_201711226|20',
    notice: 'pageclick|keycount|home_201711226|12',
    // 核心指标
    core_dept_select: 'pageclick|keycount|home_201711226|21',
    core_ihsKPI: 'pageclick|keycount|home_201711226|22',
    core_salePlanFinishPer: 'pageclick|keycount|home_201711226|23',
    core_pbsKPIEmg: 'pageclick|keycount|home_201711226|24',
    core_pbsKPIUnits: 'pageclick|keycount|home_201711226|25',
    core_vrsReturnNum: 'pageclick|keycount|home_201711226|26',
    core_vrsReturnSumMoney: 'pageclick|keycount|home_201711226|27',
    trend_chart: 'pageclick|keycount|home_201711226|28',
    trend_dateGran_day: 'pageclick|keycount|home_201711226|29',
    trend_dateGran_month: 'pageclick|keycount|home_201711226|30',
    trend_dateGran_week: 'pageclick|keycount|home_201711226|31',
    trend_dept_select: 'pageclick|keycount|home_201711226|33',
  },
  index: {
    header_use: 'pageclick|keycount|login_201711225|1',
    header_seller: 'pageclick|keycount|login_201711225|2',
    header_operate: 'pageclick|keycount|login_201711225|3',
    footer_about: 'pageclick|keycount|login_201711225|5',
    footer_contact: 'pageclick|keycount|login_201711225|6',
    footer_reg: 'pageclick|keycount|login_201711225|7',
    footer_use: 'pageclick|keycount|login_201711225|8',
    footer_questions: 'pageclick|keycount|login_201711225|9',
    footer_documents: 'pageclick|keycount|login_201711225|10',
  },
  // 商家工作台
  logTags: [
    {tarCode: '8_01', name: '存货总体分析', targetLocation: 'home_com_il'},
    {tarCode: '8_02', name: '库存总体分析', targetLocation: 'home_com_ihs'},
    {tarCode: '8_03', name: '销量总体分析', targetLocation: 'home_com_sfs'},
    {tarCode: '8_04', name: '预测补货', targetLocation: 'home_com_pbs_prediction'},
    {tarCode: '8_05', name: '分仓补货', targetLocation: 'home_com_pbs_separate'},
    {tarCode: '8_06', name: '滞销处理建议', targetLocation: 'home_com_vrs'},
    {tarCode: '8_07', name: '销量计划', targetLocation: 'home_will_sfs'},
    {tarCode: '8_08', name: '滞销处理', targetLocation: 'home_will_vrs'},
    {tarCode: '8_09', name: 'notice_1', targetLocation: 'home_notice_1'},
    {tarCode: '8_10', name: 'notice_2', targetLocation: 'home_notice_doc'},
    {tarCode: '8_11', name: 'notice_3', targetLocation: 'home_notice_4'},
    {tarCode: '8_12', name: 'notice_4', targetLocation: 'home_notice_questions'},
    {tarCode: '8_13', name: 'notice_5', targetLocation: 'home_notice_6'},
    {tarCode: '8_14', name: '需补货商品个数', targetLocation: 'home_core_pbs_number'},
    {tarCode: '8_15', name: '需补货商品总量', targetLocation: 'home_core_pbs_total'},
    {tarCode: '8_16', name: '已滞销商品总数', targetLocation: 'home_core_vrs_total'},
    {tarCode: '8_17', name: '退货金额', targetLocation: 'home_core_vrs_returnSum'},
    {tarCode: '8_18', name: 'day', targetLocation: 'home_trend_day'},
    {tarCode: '8_19', name: 'week', targetLocation: 'home_trend_week'},
    {tarCode: '8_20', name: 'month', targetLocation: 'home_trend_month'}
  ]
}
